import { render, staticRenderFns } from "./FeedBody.vue?vue&type=template&id=4ff46d56&scoped=true&"
import script from "./FeedBody.vue?vue&type=script&lang=js&"
export * from "./FeedBody.vue?vue&type=script&lang=js&"
import style0 from "./FeedBody.vue?vue&type=style&index=0&id=4ff46d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff46d56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
